export const CMS_ITEMS = {
  STATIONS: "stations",
  AIRLINE: "airlines",
};

export const CMS_PARAMS = {
  stations: {
    fields:
      "type,station_name_en,location_code,sub_type,city_name_en,iso_country",
    deep: "*",
  },
  airline: {
    fields: "name, icon, icon_tail, display_name, short_code",
    limit: `-1`,
    "filter[status][_eq]": "published",
  },
};
